import moduleCollapsible from '../../modules/module--collapsible';

export default function() {
    moduleCollapsible.add({
        block: '.collapsible-topic-head',
        elToggle: '.collapsible-topic-head__toggle',
        elContent: '.collapsible-topic-head__content',
        classOpenLoad: '--open-onload',
        closeOutside: false,
        closeAny: false,
        closeOthers: false,
        speed: 200,
        debug: false,
        matchElements($toggleClicked, { block, elContent }) {
            const $elBlock = $toggleClicked.closest(block);
            const $elContent = $elBlock.children(elContent);
            return {
                $activeBlock: $elBlock,
                $activeToggle: $toggleClicked,
                $activeContent: $elContent
            };
        }
    });
}
